import React, { useState, useEffect } from "react";
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Card, CardBody, Table, Row, Col, UncontrolledTooltip, FormGroup, Form } from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../../components/Common/Breadcrumb";
import Select from "../../../../../components/Common/custom-select";
import "react-datepicker/dist/react-datepicker.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import {
  fetchCategories,
  fetchDepartments,
  fetchDesignations,
  fetchEmployeeDropdownAutoList,
  fetchShiftLateApproval,
  fetchShiftLateApprovalEmployeeRequest,
  fetchShiftLateCancel,
  fetchShiftLateCancelEmployeeRequest,
  resetShiftLateCancel,
  saveShiftLateApproval,
  saveShiftLateCancel,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { FiCalendar, FiEye, FiRepeat, FiSave, FiSearch } from "react-icons/fi";
import CustomDatePicker from "common/CustomDatePicker";
import { FaCheck } from "react-icons/fa";
import CustomSelect from "../../../../../components/Common/custom-select";
import Loader from "common/pageLoader"
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";

const TimeDeductionShiftLateCancel = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const {
    categories,
    departments,
    designations,
    dropdownAutoList,
    shiftLateCancelData,
    shiftLateCancelEmployeeList,
    loading,
    success,
    error,
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories,
    departments: state.DepartmentMaster?.departments,
    designations: state.DesignationMaster?.designations,
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList,
    shiftLateCancelData: state.AttendanceTimeDeductionsReducer?.shiftLateCancelData,
    shiftLateCancelEmployeeList: state.AttendanceTimeDeductionsReducer?.shiftLateCancelEmployeeList,

    loading: state.AttendanceTimeDeductionsReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.AttendanceTimeDeductionsReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.AttendanceTimeDeductionsReducer?.success
  }));
  
  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);
    
  useEffect(() => {
      if(success){
          const formData = new FormData();
          formData.append("from_date", formik.values?.fromDate);
          formData.append("to_date", formik.values?.toDate);
          formData.append("emp_id", modalData?.emp_id);
          dispatch(fetchShiftLateCancelEmployeeRequest(formData));
      }
  }, [authDetails,success,dispatch]);

  const [shiftLateData, setShiftLateData] = useState();
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [counts, setCounts] = useState({
    Approve: 0,
    Reject: 0,
    Discussion: 0,
  });

  useEffect(() => {
    if (shiftLateCancelEmployeeList && shiftLateCancelEmployeeList.length > 0) {
      const initializedData = (shiftLateCancelEmployeeList || []).map(row => ({
        ...row,
        selectedOption: null,
        remarks: ""
      }));
      setShiftLateData(initializedData)
    }else{
      setModal(false)
    }
  }, [shiftLateCancelEmployeeList])

  useEffect(() => {
    dispatch(resetShiftLateCancel())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId));
  }, [dispatch]);

  const validationSchema = Yup.object({
    fromDate: Yup.date().nullable()
      .required("From Date is required"),

    toDate: Yup.date().nullable()
      .required("To Date is required")
      .test(
        "is-before-fromDate",
        "To Date cannot be before From Date",
        function (value) {
          const { fromDate } = this.parent;
          return !fromDate || !value || new Date(value) >= new Date(fromDate);
        }
      )
    // .test(
    //   "is-within-one-month",
    //   "To Date cannot be more than 1 month after From Date",
    //   function (value) {
    //     const { fromDate } = this.parent;
    //     if (!fromDate || !value) return true;
    //     const maxDate = new Date(fromDate);
    //     maxDate.setMonth(maxDate.getMonth() + 1);
    //     return new Date(value) <= maxDate;
    //   }
    // ),
  });

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      designation: "",
      fromDate: "",
      toDate: "",
      employee: "",
    },
    validationSchema,
    onSubmit: (values) => {
      // console.log('shift late > ',values)
      const formData = new FormData();
      formData.append(
        "cat_id",
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "dept_id",
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
      );
      formData.append(
        "design_id",
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
      );
      formData.append("from_date", values.fromDate);
      formData.append("to_date", values.toDate);
      formData.append(
        "emp_id",
        values.employee && values.employee.length ? values.employee.map(item => item.value).join(",") : '0'
      );

      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);

      dispatch(fetchShiftLateCancel(formData));
    },
  });

  const handleCancel = () => {
    formik.resetForm();
    dispatch(resetShiftLateCancel())
  };

  const handleOptionChange = (rowId, action) => {
    // Update the selected option for the specific row
    const updatedData = shiftLateData.map((row) => {
      if (row.late_id === rowId) {
        return { ...row, selectedOption: action };
      }
      return row;
    });

    setShiftLateData(updatedData);
  };

  const handleBulkActionChange = (action) => {
    const updatedData = shiftLateData.map((row) => ({
      ...row,
      selectedOption: action,
    }));
    setShiftLateData(updatedData);
  };

  const handleRemarksChange = (sno, value) => {
    const updatedData = (shiftLateData || []).map((item) =>
      item.late_id === sno ? { ...item, remarks: value } : item
    );
    setShiftLateData(updatedData);
  };

  const formatTimeWithColon = (val) => {
    const digits = val.replace(/\D/g, "").slice(0, 4);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}:${digits.slice(2)}`;
  };

  const timeToMinutes = (time) => {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handleHourChange = (value, rowIndex) => {
    let input = value.trim();

    // If no colon is present
    if (!input.includes(":")) {
      const digitsOnly = input.replace(/\D/g, "");

      if (digitsOnly.length === 1) {
        input = `0${digitsOnly}:00`; // e.g., "3" → "03:00"
      } else if (digitsOnly.length === 2) {
        input = `${digitsOnly}:00`; // e.g., "12" → "12:00"
      }
      // if more than 2 digits, let formatTimeWithColon handle it
    }

    const formatted = formatTimeWithColon(input); // Converts user input to "HH:MM"
    const updated = [...shiftLateData];

    const approvedMinutes = timeToMinutes(formatted);
    const appliedMinutes = timeToMinutes(updated[rowIndex].applied_hours);

    if (approvedMinutes > appliedMinutes) {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid Entry',
        text: 'Approved hours cannot be greater than total hours.',
      });
      updated[rowIndex].approved_hours = updated[rowIndex].applied_hours; // Reset to original
    } else {
      updated[rowIndex].approved_hours = formatted;
    }

    setShiftLateData(updated);
  };

  const columns = [
    {
      Header: "Action",
      Cell: (cellProps) => {
        return (
          <div className="d-flex gap-3">  
              <Link
                to="#"
                onClick={() => handleView(cellProps.row.original)}
              >
                <i className="mdi mdi-cog font-size-18" id={`edittooltip-${cellProps.row.original?.s_no}`} />
                <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original?.s_no}`}>
                  Late Approval
                </UncontrolledTooltip>
              </Link>        
          </div>
        );
      },
    },
    { Header: "S.No", Cell: ({ row }) => shiftLateCancelData.length - row.index, className: "serial-no text-center", applyHeaderClass: true,},
    { Header: "Date", accessor: "attendance_month" },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Tot Hrs", accessor: "total_hours" },
    
  ];

  const columns_approved = [
    { Header: "S.No", Cell: ({ row }) => shiftLateData.length - row.index, className: "serial-no", applyHeaderClass: true,},
    { Header: "Date", accessor: "punch_date" },
    { Header: "From", accessor: "from_time" },
    { Header: "To", accessor: "to_time" },
    { Header: "Reason", accessor: "reason" },
    { Header: "Tot Hrs", accessor: "applied_hours" },
    {
      Header: "App Hrs",
      accessor: "approved_hours",
    },
    {
      Header: "Remarks",
      Cell: ({ row }) => {
        const rowIndex = row.index;
        const [value, setValue] = useState(shiftLateData[rowIndex]?.remarks || "");

        const handleBlur = () => {
          if (value) {
            handleRemarksChange(row.original.late_id, value);
          }
        };

        return (
          <Input
            type="text"
            bsSize="sm"
            placeholder="Enter remarks"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onBlur={handleBlur} // only update global state on focus out
          />
        );
      }
    },
    {
      id: "cancel",
      Header: () => (
        <div className="text-center">
          Cancel <br />
          <Input
            type="radio"
            name="selectAll"
            onChange={() => handleBulkActionChange("Cancel")}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={() => handleOptionChange(row.original.late_id, "Cancel")}
          style={{ cursor: "pointer" }}
        >
          {row.original.selectedOption === "Cancel" ? (
            <FaCheck color="green" size={20} />
          ) : (
            <Input
              type="radio"
              name={`action-${row.original.late_id}`}
              onChange={() => handleOptionChange(row.original.late_id, "Cancel")}
              checked={row.original.selectedOption === "Cancel"}
            />
          )}
        </div>
      ),
    },
    {
       id: "hold",
       Header: () => (
        <div className="text-center">
          Hold <br />
          <Input
            type="radio"
            name="selectAll"
            onChange={() => handleBulkActionChange("Hold")}
          />
        </div>
      ),
      Cell: ({ row }) => (
        <div
          className="d-flex justify-content-center align-items-center"
          onClick={() => handleOptionChange(row.original.late_id, "Hold")}
          style={{ cursor: "pointer" }}
        >
          {row.original.selectedOption === "Hold" ? (
            <FaCheck color="orange" size={20} />
          ) : (
            <Input
              type="radio"
              name={`action-${row.original.late_id}`}
              onChange={() => handleOptionChange(row.original.late_id, "Hold")}
              checked={row.original.selectedOption === "Hold"}
            />
          )}
        </div>
      ),
    },
  ];

  const handleView = (rowData) => {
    if (!formik.values.fromDate || !formik.values.toDate) {
      Swal.fire({
          icon: "warning",
          title: "Missing Dates",
          text: "Please select both From and To dates before proceeding.",
        });
      return;
    }
    
    const formData = new FormData();
    formData.append("from_date", formik.values?.fromDate);
    formData.append("to_date", formik.values?.toDate);
    formData.append("emp_id", rowData?.emp_id);
    dispatch(fetchShiftLateCancelEmployeeRequest(formData));
    setModalData(rowData); 
    setModal(true);
  };

  const handleLateApprove = ()=>{
    const updatedClaims = (shiftLateData || [])
      .filter(item => item.selectedOption !== null && item.selectedOption !== undefined)
      .map(item => {
        const approvalFlags = {
          Cancel: { approve: "0", reject: "1", hold: "0" },
          Hold: { approve: "0", reject: "0", hold: "1" }
        };

        const flags = approvalFlags[item.selectedOption] || { approve: "0", reject: "0", hold: "0" };

        return {
          late_id: item.late_id,
          ...flags,
          remarks: item.remarks || "",
          approved_hours: item.approved_hours || "0"
        };
      });
    if(updatedClaims && updatedClaims.length <= 0){
      Swal.fire({
          icon: "warning",
          title: "No Selection",
          text: "Please select at least one before proceeding.",
        });
      return;
    }

    const missingRemarks = (shiftLateData || [])
      .filter(item => item.selectedOption === "Cancel" && (!item.remarks || item.remarks.trim() === ""));

    if (missingRemarks.length > 0) {
      const missingList = missingRemarks
        .map(item => `Punch Date : ${item.punch_date}`)
        .join(", ");

      Swal.fire({
        icon: "warning",
        title: "Remarks Required",
        text: `Please enter remarks for: ${missingList}`,
      });
      return;
    }
    
    const payload = { lateprocess: updatedClaims };
    const convertObject = JSON.stringify(payload);
    const formData = new FormData();
    formData.append("items", convertObject);
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);
    dispatch(saveShiftLateCancel(formData))
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          <Breadcrumbs title="Time Deductions" breadcrumbItem="Late Cancel" />

          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="department">Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                        value={formik.values.department || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="designation">Designation</Label>
                      <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                        value={formik.values.designation || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.designation && formik.errors.designation && (
                        <div className="text-danger">{formik.errors.designation}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Employee Selection */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* From Date */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        name="fromDate"
                        value={formik.values.fromDate}
                        onChange={(date) => formik.setFieldValue("fromDate", date)}
                        onBlur={formik.handleBlur}
                        disableFuture={true}
                        className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.fromDate && formik.errors.fromDate && (
                        <div className="text-danger">{formik.errors.fromDate}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* To Date */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        name="toDate"
                        value={formik.values.toDate}
                        onChange={(date) => formik.setFieldValue("toDate", date)}
                        onBlur={formik.handleBlur}
                        disableFuture={true}
                        className={`form-control ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.toDate && formik.errors.toDate && (
                        <div className="text-danger">{formik.errors.toDate}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* Buttons */}
                  <Col md={6} sm={12} className="d-flex align-items-center justify-content-end mob-center">
                    <Button type="submit" className="btn button-search me-2">
                      <i className="fas fa-search me-1" /> Search
                    </Button>
                    {/* <Button type="button" color="primary" className="me-2">
                      <FiSave/>Submit
                    </Button> */}
                    <Button type="button" onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          <Card>
            <CardBody>
              <TableContainer columns={columns} data={shiftLateCancelData && shiftLateCancelData.length > 0 ? shiftLateCancelData : []} isGlobalFilter={true} customPageSize={10} />
            </CardBody>
          </Card>
        </Container>

        <Modal isOpen={modal && shiftLateData} toggle={() => setModal(false)} size="xl" centered>
          <ModalHeader toggle={() => setModal(false)}>Punch Orders</ModalHeader>
          <ModalBody>
            <Card >
                <CardBody>
                      <div>
                        <div className="timesheet-summary d-flex flex-wrap justify-content-between align-items-center p-0  mb-3 gap-2" style={{ fontSize: "0.85rem" }}>
                        <div className="d-flex align-items-center ">
                          <p className="pe-2 mb-0 border-right border-end border-2 border-dark"><strong >Emp No:</strong> <span className="text-danger">{modalData?.emp_no}</span></p>
                          <p className="px-2 mb-0"><strong >Emp Name:</strong> <span className="text-danger">{modalData?.emp_name}</span></p>
                        </div>
                        {/* <div>
                          <p className="mb-0"><strong>Date:</strong> <span className="text-danger">01/01/2023</span></p>
                        </div> */}
                        <div className="d-flex align-items-center gap-3">
                          <p className="mb-0"><strong>Total Hrs:</strong> <span className="text-danger">{modalData?.total_hours}</span></p>
                          {(canEdit || canApprove) && (
                            <Button className="btn btn-primary btn-sm" onClick={handleLateApprove}>Update</Button>
                          )}
                        </div>
                      </div>

                        <div className="timesheet-table">
                          <TableContainer
                            columns={columns_approved}
                            data={shiftLateData && shiftLateData.length > 0 ? shiftLateData : []}
                            customPageSize={5}
                            isGlobalFilter={false}
                            tableSorter={false}
                          />
                        </div>
                      </div>
                  </CardBody>
              </Card> 
          </ModalBody>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default TimeDeductionShiftLateCancel;
